export default __webpack_public_path__ + "static/mightyC-84ca0c527a27732a54d9598f1e2cb0c9.jpg";